import { render } from "./Footer.vue?vue&type=template&id=ec7e2f2e&scoped=true"
const script = {}

import "./style.scss?vue&type=style&index=0&id=ec7e2f2e&lang=scss&scoped=true"

import exportComponent from "/Users/kobayashiyasutaka/Documents/Projects/murakihp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec7e2f2e"]])

export default __exports__